import FeaturePreview from './FeaturePreview.vue';

export default FeaturePreview;
